export enum PendencyStatusEnum {
  Opened = "Opened",
  Closed = "Closed" 
}



// WEBPACK FOOTER //
// ./src/services/Enum/pendency/PendencyStatusEnum.ts